import { IconRalphWiggum } from "@/assets/icons/IconRalphWiggum";
import { IconCheckCircle } from "@/assets/icons/geist/IconCheckCircle";
import type { AgentMessageFragmentAgentModeChange } from "@/hooks/use-stream-conversation";
import { IconSearchlinesSparkle } from "@central-icons-react/round-outlined-radius-2-stroke-1.5/IconSearchlinesSparkle";
import { type FC } from "react";

export const FragmentAgentModeChange: FC<{
    fragment: AgentMessageFragmentAgentModeChange;
}> = ({ fragment }) => {
    if (fragment.state === "onaSpecComplete") {
        return (
            <div className="mt-2 flex items-center gap-2 text-sm text-content-brand-accent-01">
                <div className="relative">
                    <IconSearchlinesSparkle size={20} />
                    <IconCheckCircle
                        size="sm"
                        className="absolute -bottom-1 -right-1 rounded-full bg-surface-primary text-content-success"
                    />
                </div>
                <span>Planning complete. Starting implementation...</span>
            </div>
        );
    }

    return (
        <div className="mt-2 flex items-center gap-2 text-sm text-content-secondary">
            <IconRalphWiggum size={20} />
            <span>{fragment.message}</span>
        </div>
    );
};
